// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
// hooks
import { usePatientId } from "../../../hooks/usePatientId";
// auth
import { useAuthContext } from "../../../auth/useAuthContext";
// import { useAllowedNavItems } from "../../../hooks/useAllowedNavLinks";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  till: icon("ic_till"),
  recalls: icon("ic_recalls"),
  reporting: icon("ic_repo"),
  debits: icon("ic_debits"),
};

// ----------------------------------------------------------------------

const useNavConfig = () => {
  const { user } = useAuthContext();
  const { patientId } = usePatientId();
  // Show all items in the sidebar regardless of role/allowedTitles

  // Determine the patient path based on user role and patientId
  const patientPath =
    user?.roleId === "patient" && patientId
      ? PATH_DASHBOARD.patients.detail(patientId)
      : PATH_DASHBOARD.patients.list;

  // Determine the dispense path based on user role
  const dispensePath =
    user?.roleId === "patient"
      ? PATH_DASHBOARD.dispense.detail(1)
      : PATH_DASHBOARD.dispense.list;

  // Determine the till path based on user role
  const tillPath =
    user?.roleId === "patient"
      ? PATH_DASHBOARD.till.detail(user?.id || 1)
      : PATH_DASHBOARD.till.list;

  // Define all possible nav items
  const allItems = [
    {
      subheader: "management",
      items: [
        {
          title: "diary",
          path: PATH_DASHBOARD.diary.list,
          icon: ICONS.calendar,
          disabled: false,
        },
        {
          title: "patient",
          path: patientPath,
          icon: ICONS.kanban,
          disabled: false,
        },
        {
          title: "dispense",
          path: dispensePath,
          icon: ICONS.invoice,
          disabled: false,
        },
        {
          title: "till",
          path: tillPath,
          icon: ICONS.till,
          disabled: false,
        },
        {
          title: "product",
          path: PATH_DASHBOARD.product.list,
          icon: ICONS.ecommerce,
          disabled: false,
        },
        {
          title: "recalls",
          path: PATH_DASHBOARD.recalls,
          icon: ICONS.recalls,
          disabled: false,
        },
        {
          title: "reporting",
          path: PATH_DASHBOARD.reporting,
          icon: ICONS.reporting,
          disabled: false,
        },
        {
          title: "direct debits",
          path: PATH_DASHBOARD.debits,
          icon: ICONS.debits,
          disabled: false,
        },
      ],
    },
  ];

  return allItems;
};

export { useNavConfig };
export default useNavConfig;
